import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HelpCircle, Plus, Minus } from 'lucide-react';

const FAQ_KEYS = ['who', 'cost', 'public_private', 'certification', 'blended', 'languages', 'funding', 'data_ownership'];

const FAQSection = () => {
  const { t } = useTranslation();
  const [openKey, setOpenKey] = useState(FAQ_KEYS[0]);

  return (
    <section id="faq" className="py-20 md:py-24 bg-white border-t border-slate-100">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-emerald-700 text-sm font-semibold tracking-wider uppercase mb-3 inline-flex items-center gap-2 justify-center">
            <HelpCircle className="w-4 h-4" /> {t('landing.faq.eyebrow')}
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900">{t('landing.faq.title')}</h2>
          <p className="mt-4 text-slate-600">{t('landing.faq.subtitle')}</p>
        </div>

        <div className="space-y-2">
          {FAQ_KEYS.map((k) => {
            const open = openKey === k;
            return (
              <div
                key={k}
                className={`rounded-xl border transition-all ${open ? 'border-emerald-300 bg-emerald-50/30 shadow-sm' : 'border-slate-200 bg-white hover:border-slate-300'}`}
                data-testid={`faq-${k}`}
              >
                <button
                  type="button"
                  onClick={() => setOpenKey(open ? null : k)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={open}
                  data-testid={`faq-toggle-${k}`}
                >
                  <span className="font-semibold text-slate-900 text-sm md:text-base">
                    {t(`landing.faq.${k}.q`)}
                  </span>
                  <span className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center ${open ? 'bg-emerald-700 text-white' : 'bg-slate-100 text-slate-500'}`}>
                    {open ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                  </span>
                </button>
                {open && (
                  <div className="px-5 pb-5 text-sm text-slate-700 leading-relaxed whitespace-pre-wrap" data-testid={`faq-answer-${k}`}>
                    {t(`landing.faq.${k}.a`)}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <p className="text-center text-sm text-slate-500 mt-10">
          {t('landing.faq.still')}{' '}
          <a href="#contact-form" className="text-emerald-700 font-semibold hover:underline">
            {t('landing.faq.contact_link')}
          </a>
        </p>
      </div>
    </section>
  );
};

export default FAQSection;
